export default 
[
    {
    id:1,
    title: 'Object-Oriented Programming (OOP)',
    description:"",
    description_card: 
    [{
         title:'1. Educational Focus',
          description:
          `Develop an understanding of object-oriented thinking and apply OOP principles to design, develop, 
    and maintain software solutions.`,

    },
    {
         title:'2. Technology',
          description:
          `<ul><li>Python and/or Java</li><li> VS Code </li></ul>`,

    },
     {
         title:'3. Educational Value',
          description:
          `<ul>
          <li>Model real-world entities as software objects.</li>
          <li>Visualise software as a collection of interacting objects rather than isolated functions.</li>
          <li>Develop computational thinking through decomposition, abstraction, and modular design.</li>
          <li>Build transferable OOP skills that can be applied to other programming languages, frameworks, and technologies.</li>
          <li>Prepare students for A-Level NEA projects and university-level software engineering.</li>
          </ul>
          `,

    },



]
  
  
   },

      {
    id:2,
    title: 'Trees, Graphs, and Spatial Problem-Solving',
    description:"",
    description_card: 
    [{
         title:'1. Educational Focus',
          description:
          `Understanding trees and graphs by representing them visually and applying them to practical problems using two-dimensional grids.`,

    },
    {
         title:'2. Technology',
          description:
          `<ul><li>Python and/or Java</li><li> VS Code </li><li>Python Pygame </li><li>2D grid representation</li></ul>`,

    },
     {
         title:'3. Educational Value',
          description:
          `
          <ul>
         
      <li>Makes abstract data structures easier to visualise.</li>
      <li>Helps students understand nodes, edges, connections, paths, and relationships.</li>
      <li>Connects tree and graph theory to practical programming.</li>
      <li>Supports computational thinking, including abstraction, decomposition, pattern recognition, and algorithm design.</li>
      <li>Provides a foundation for pathfinding algorithms such as Breadth-First Search (BFS), Depth-First Search (DFS), Dijkstra’s algorithm, and A*.</li>
      <li>Shows how the same computational ideas can be applied across different domains, including games, networking, robotics, navigation, and AI.</li>
      <li>Encourages students to move from a visual model to an algorithm and then to a working program.</li>
         </ul> 
          `,

    },



]
  
  
   },

        {
    id:3,
    title: 'Networking — Block 1: Network Communication & TCP/IP',
    description:"",
    description_card: 
    [{
         title:'1. Educational Focus',
          description:
          `Understanding how devices communicate across a network using protocols and the TCP/IP layered model.`,

    },
    {
         title:'Technology',
          description:
          ` <ul>
                <li>Linux / Ubuntu</li>
                <li> VS Code + Terminal </li>
                </ul>`,

    },
     {
         title:'Educational Value',
          description:
          `  <ul>
            <li>Converts an abstract networking model into an observable process.</li>
            <li>Connects textbook theory with real network communication.</li>
            <li>Helps students understand the relationship between protocols and TCP/IP layers.</li>
            <li>Develops computational thinking through decomposition of a complex communication process.</li>
            <li>Makes the client-server model tangible.</li>
            <li>Provides a foundation for later study of cybersecurity and web technologies.</li>
             </ul>
          `,

    },



]
  
  
   },

     {
    id:4,
    title: 'Networking — Block 2: Network Protocols & Services',
    description:"",
    description_card: 
    [{
         title:'1. Educational Focus',
          description:
          `Understanding the purpose and use of common network protocols and services.`,

    },
    {
         title:'Technology',
          description:
          ` <ul>
                <li>Linux / Ubuntu</li>
                <li> VS Code + Terminal </li>
                <li> Basic networking tools </li>
                </ul>`,

    },
     {
         title:'Educational Value',
          description:
          `  <ul>
            <li>Moves students from knowing protocol names to understanding their purposes.</li>
            <li>Demonstrates that different protocols solve different communication problems.</li>
            <li>Shows how application-level protocols operate over underlying network infrastructure.</li>
            <li>Provides authentic experience with Linux networking tools.</li>
            <li>Develops transferable technical skills useful beyond the examination specification.</li>
             </ul>
          `,

    },



]
  
  
   },
    {
    id:5,
    title: 'Networking — Block 3: Secure Network Communication',
    description:"",
    description_card: 
    [{
         title:'1. Educational Focus',
          description:
          `Understanding how network communication can be secured using encryption, certificates, authentication and secure protocols.`,

    },
    {
         title:'Technology',
          description:
          ` <ul>
                <li>Linux / Ubuntu</li>
                <li> VS Code + Terminal </li>
                <li> SSH</li>
                <li> VPS (optional)</li>
                </ul>`,

    },
     {
         title:'Educational Value',
          description:
          `  <ul>
            <li> Makes cybersecurity concepts concrete.</li>
            <li> Connects cryptography theory with real-world communication.</li>
            <li> Helps students understand why + how HTTPS is different from HTTP.</li>
            <li> Makes certificates and TLS less abstract.</li>
            <li> Demonstrates how several Computer Science concepts work together in a real system.</li>
            <li> Creates a natural bridge between Networking → Cybersecurity → Web Development.</li>
             </ul>
          `,

    },



]
  
  
   },

        {
    id:6,
    title: 'ADTs & Data Structures',
    description:"",
    description_card: 
    [{
         title:'Educational Focus',
          description:
          `Understanding Abstract Data Types (ADTs), data structures, their relationships, and how data structures can be designed and implemented to solve computational problems.`,

    },
    {
         title:'Technology',
          description:
          ` <ul>
                <li>Python and/or Java</li>
                <li> VS Code + Terminal </li>
                <li> Pseudocode + Visual diagrams </li>
                </ul>`,

    },
     {
         title:'Educational Value',
          description:
          `<ul>
           <li>Helps students distinguish between an <b>abstract data type</b> and its <b>implementation</b>.</li>
            <li>Develops the ability to translate an abstract specification into pseudocode and working code.</li>
            <li>Builds understanding of how different data structures support different operations.</li>
            <li>Demonstrates how one structure can be implemented using another structure.</li>
            <li>Develops computational thinking through decomposition and abstraction.</li>
            <li>Strengthens algorithmic problem-solving.</li>
            <li>Allows students to compare implementations in terms of operations, efficiency and suitability.</li>
            <li>Provides transferable knowledge for university-level Computer Science and software development.</li>
          </ul>
          
          `,

    },



]
  
  
   },
 /*
    {
    id:7,
    title: 'Introduction to Graphics',
    description:"Some simple description here later",
    description_card: 
    [{
         title:'Educational Focus',
          description:
          `Develop an understanding of object-oriented thinking and apply OOP principles to design, develop, 
    and maintain software solutions.`,

    },
    {
         title:'Technology',
          description:
          `Python + VS Code <br>Java + VS Code`,

    },
     {
         title:'Educational Value',
          description:
          `
          - Model real-world entities as software objects.<br><br>
          - Visualise software as a collection of interacting objects rather than isolated functions.<br><br>
          - Develop computational thinking through decomposition, abstraction, and modular design.<br><br>
          - Build transferable OOP skills that can be applied to other programming languages, frameworks, and technologies.<br><br>
          - Prepare students for A-Level NEA projects and university-level software engineering.<br><br>
          
          `,

    },



]
  
  
   },

    {
    id:8,
    title: '2D Game Development',
    description:"Some simple description here later",
    description_card: 
    [{
         title:'Educational Focus',
          description:
          `Develop an understanding of object-oriented thinking and apply OOP principles to design, develop, 
    and maintain software solutions.`,

    },
    {
         title:'Technology',
          description:
          `Python + VS Code <br>Java + VS Code`,

    },
     {
         title:'Educational Value',
          description:
          `
          - Model real-world entities as software objects.<br><br>
          - Visualise software as a collection of interacting objects rather than isolated functions.<br><br>
          - Develop computational thinking through decomposition, abstraction, and modular design.<br><br>
          - Build transferable OOP skills that can be applied to other programming languages, frameworks, and technologies.<br><br>
          - Prepare students for A-Level NEA projects and university-level software engineering.<br><br>
          
          `,

    },



]
  
  
   },µ*/



  
  
 ]